import { Axios } from "utils";

export const getCertificateInfo = async (id) => {
  const res = await Axios.get(`certificate/${id}`);
  return res.data;
};
